import axios from 'axios';

if (process.env.NODE_ENV !== 'development') {
  axios.defaults.baseURL = process.env.DOMAIN;
}

axios.interceptors.request.use(
  request => {
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios;
